// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5140) return "static/chunks/5140-bdd6c36ce9007f77.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"1009":"7269c102","1064":"ab20df8b","7412":"4d47a0c6"}[chunkId] || chunkId) + "." + {"906":"e8960d7124f0bde2","1009":"8c6a003c2d24a397","1064":"2f7af83e480cb151","1377":"564cbd7a51858b54","4915":"0647b4a80b605671","7143":"77acf9f6261639e9","7412":"d5e714be988b26aa","8090":"cf39d4ce25a7977d","8434":"99630ebc75e174a8"}[chunkId] + ".js";
};